import { getLinkByKey } from '$cms/getDataByKey';
import type { CmsContentDictionary } from '$cms/index';

export const getCmsData = (cmsData: CmsContentDictionary) => {
  const getLink = getLinkByKey.bind(cmsData);

  return {
    loginLink: getLink('navbar.link.login', {
      text: 'Login | Sign-up',
      url: '/login',
    }),
  };
};
